import React from 'react'
import styles from './styles.module.scss'
import { useFormik } from 'formik'
import { Input } from './Components'
import { useDispatch, useSelector } from 'react-redux'
import { auth } from '../../actions/auth'
import { Navigate, useLocation } from 'react-router-dom'
import * as Yup from 'yup'


const validationSchema = Yup.object().shape({
  login: Yup.string().required('обязательное поле').max(50, 'Должно быть не более 50 символов'),
  password: Yup.string().required('обязательное поле').max(50, 'Должно быть не более 50 символов'),
})

export default function Auth() {

  const dispatch = useDispatch()
  const { access_token, authError } = useSelector(state => state.auth)
  const location = useLocation()

  const handleSub = (values) => dispatch(auth(values))

  const {
    values,
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    touched,
  } = useFormik({
    initialValues: { login: null, password: null },
    onSubmit: handleSub,
    validationSchema: validationSchema
  })


  if (access_token) return <Navigate to={location.state?.from || '/dashboard'} />

  const error = (fieldName) => touched[fieldName] && errors[fieldName]

  return (
    <div className={styles.wrapper}>

      {/* <header className={styles.header}>
        <br />
        <img src='/images/LMSLogo.png' alt='o_O' />
        <h1>Система управления обучением</h1>
      </header> */}
      <main>
        <form onSubmit={handleSubmit} className={styles.form}>
          {!!authError && (
            <div className={styles.errorPopup}>
              <span className={styles.errorPopupIcon}>!</span>
              <span className={styles.errorPopupText}>{authError}</span>
            </div>
          )}
          <h1>Авторизация</h1>
          <Input
            name='login'
            value={values.login}
            placeholder='Логин'
            onChange={handleChange}
            onBlur={handleBlur}
            error={error('login')}
          />
          <Input
            name='password'
            type='password'
            value={values.password}
            placeholder='Пароль'
            onChange={handleChange}
            onBlur={handleBlur}
            error={error('password')}

          />
          <button type='submit'>Вход</button>
        </form>

      </main>


      {/* <footer className={styles.footer}>
        <div>
          <span>www.nintegra.ru</span>
        </div>
        <div>
          <span>+7(495)780-76-71</span>
        </div>
        <div className={styles.version}>Версия {version}</div>
      </footer> */}
    </div>
  )
}
